var exports = {
  "D": "x2b2fbebb--140722--title",
  "P": "x2b2fbebb--140722--textarea",
};

module.exports = exports;
